var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"לבנות תוכנית אישית לשנים הבאות עם יועץ מומחה","button-text":"לפרטים על התוכנית","description":"ייעוץ אישי, בתשלום","action-key":_vm.actionKey},on:{"click":_vm.openAdvisoryFlow}})}
var staticRenderFns = []

export { render, staticRenderFns }